// ----------------------------------------------------------------------
// Custom themes registry
//
// Single source of truth for the optional "skins" an admin can turn on/off
// at runtime (Configurações → Tema do aplicativo). The *active* theme id is
// stored server-side (Redis) — see src/api/app-config.js — so turning one on
// affects every user after a reload, without a merge request.
//
// To ADD or REPLACE a theme: add/edit an entry below and drop its assets in
// public/assets/themes/. No other code change is required for the header
// image. Optional `palette`/`components` fields are reserved for evolving the
// cards/look-and-feel later (not consumed yet — keep them documented here).
// ----------------------------------------------------------------------

export const CUSTOM_THEMES = {
  worldcup: {
    id: 'worldcup',
    label: 'Copa do Mundo',
    // Background image for the consolidated report header.
    // File at: public/assets/themes/worldcup-header.webp
    headerImage: '/assets/themes/worldcup-header.webp',
    // Optional: header banner height (number of px or MUI responsive object).
    // Defaults to { xs: 200, md: 340 } when omitted.
    // headerHeight: { xs: 220, md: 380 },
    //
    // Image proportion (width / height). In the "background" layout this makes
    // the image expand to the full width keeping its proportion (no crop).
    headerAspectRatio: 1672 / 941,
    //
    // Optional: when true, the theme is mandatory — users cannot opt out of it
    // (the per-user "Tema especial" toggle is hidden). Defaults to false, i.e.
    // each user may turn the theme off for themselves.
    // forced: true,
    //
    // Optional: first-visit overlay (black transparent backdrop + centered
    // image, shown once per user). Bump `version` to re-show after an update.
    // Leave undefined to disable. See ThemeIntroOverlay.
    // intro: { image: '/assets/themes/worldcup-intro.webp', version: 1 },
    //
    // Optional, for future look-and-feel work (not applied yet):
    // palette: { primary: { main: '#...' } },
    // components: { MuiCard: { styleOverrides: { root: { ... } } } },
  },
  'concrete-show-2026': {
    id: 'concrete-show-2026',
    label: 'Concrete Show 2026',
    headerImage: '/assets/themes/concrete-show-2026-header.webp',
    headerAspectRatio: 1672 / 941,
    // Mandatory for everyone — no per-user opt-out.
    forced: true,
  },
};

// List for admin UI (select/toggle).
export const CUSTOM_THEME_OPTIONS = Object.values(CUSTOM_THEMES).map(({ id, label }) => ({
  id,
  label,
}));

// Resolve a stored theme id to its definition (null = no/unknown theme).
export function getCustomTheme(themeId) {
  if (!themeId) return null;
  return CUSTOM_THEMES[themeId] || null;
}
